export enum FileRemoveType {
  REMOVE_FILE_ONLY = 'REMOVE_FILE_ONLY',
  REMOVE_FILE_FROM_LIST = 'REMOVE_FILE_FROM_LIST'
}
